import React from 'react';
import { Dialog, Image, T } from '@colonist/ui';
import styles from './RewardsProgramDialog.module.scss';
/** Dialog promoting referral rewards unlocked by inviting friends. */ export function RewardsProgramDialog({ open, onClose, onConfirm, rewards }) {
    const handleConfirm = ()=>{
        onConfirm();
        onClose();
    };
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose
    }, /*#__PURE__*/ React.createElement(Dialog.Title, null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:homePage.popups.rewardsProgram.title'
        }
    })), /*#__PURE__*/ React.createElement(Dialog.Content, null, /*#__PURE__*/ React.createElement("div", {
        className: styles.container
    }, /*#__PURE__*/ React.createElement("p", {
        className: styles.body
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:homePage.popups.rewardsProgram.body'
        }
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.rewards
    }, rewards.map((reward)=>/*#__PURE__*/ React.createElement("div", {
            className: styles.reward,
            key: reward.referralCount
        }, /*#__PURE__*/ React.createElement(Image, {
            className: styles.rewardImage,
            image: reward.image
        }), /*#__PURE__*/ React.createElement("h4", {
            className: styles.rewardName
        }, /*#__PURE__*/ React.createElement(T, {
            id: reward.name
        })), /*#__PURE__*/ React.createElement("p", {
            className: styles.rewardDescription
        }, /*#__PURE__*/ React.createElement(T, {
            id: {
                key: 'strings:homePage.popups.rewardsProgram.description',
                options: {
                    count: reward.referralCount
                }
            }
        }))))))), /*#__PURE__*/ React.createElement(Dialog.ButtonFooter, null, /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.ConfirmButton, {
        onClick: handleConfirm
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:homePage.popups.rewardsProgram.button'
        }
    }))));
}
